var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSavingNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.18729 0.250014C1.13257 0.18164 1.06492 0.124712 0.988202 0.0824808C0.911484 0.0402501 0.827199 0.0135437 0.740159 0.0038864C0.564375 -0.0156174 0.388043 0.0355076 0.249953 0.146014C0.111864 0.256521 0.0233291 0.417358 0.00382536 0.593142C-0.0156784 0.768926 0.0354466 0.945258 0.145954 1.08335L2.47929 4.00001L0.145954 6.91668C0.0354466 7.05477 -0.0156784 7.2311 0.00382536 7.40689C0.0233291 7.58267 0.111864 7.74351 0.249953 7.85401C0.388043 7.96452 0.564375 8.01565 0.740159 7.99614C0.915943 7.97664 1.07678 7.8881 1.18729 7.75001L3.85395 4.41668C3.94862 4.29844 4.0002 4.15148 4.0002 4.00001C4.0002 3.84854 3.94862 3.70159 3.85395 3.58335L1.18729 0.250014Z",
    fill: "#797B80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingNextIcon);
export default __webpack_public_path__ + "static/media/savingNextIcon.9326a33211128a5cb176ae65875f30eb.svg";
export { ForwardRef as ReactComponent };